import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';

import { AuthTokenService } from '@intranet/core/services/authtoken.service';

@Component({
    templateUrl: './admin-import.component.html',
})
export class AdminImportComponent implements OnInit {
    message: string;
    buttonStatus: string = 'import';
    importedSuccessfully: boolean;

    ngOnInit(): void {
        this.http
            .get(`/api/Admin/GetImportStatus`)
            .pipe(map((r) => r.text()))
            .subscribe((r) => (this.message = r));
    }

    constructor(private http: AuthTokenService) {}

    importButton(): string {
        return 'btn-primary';
    }

    doImport() {
        if (this.buttonStatus === 'import') {
            this.buttonStatus = 'areyousure';
        } else if (this.buttonStatus === 'areyousure') {
            this.buttonStatus = 'importing';
            this.importedSuccessfully = false;
            this.http.get(`/api/Admin/Import`).subscribe((r) => {
                this.buttonStatus = 'import';
                this.importedSuccessfully = true;
            });
        }
    }
}
